import { cast, types } from 'mobx-state-tree';

import { ComponentChecklist } from '../../rxdb/componentChecklist/queryBuilder';
export const SaveChecklist = types
  .model({
    isChanged: types.boolean,
    tempData: types.maybeNull(
      types.array(
        types.model({
          checkListComponentName: types.maybeNull(types.string),
          assetCategoryComponent: types.maybeNull(types.number),
          fk_Component: types.maybeNull(types.number),
          pk_uuid: types.maybeNull(types.string),
          checked: types.maybeNull(types.boolean),
          isDelete: types.maybeNull(types.string),
          sort: types.maybeNull(types.number),
          pk_AssetInspectionComponentChecklist: types.maybeNull(types.string),
          isChanged: types.maybeNull(types.boolean),
        }),
      ),
    ),
  })
  .views(self => ({
    get isChangedTrue() {
      return self.isChanged;
    },
    get checkListData() {
      return self.tempData?.toJSON();
    },
  }))
  .actions(self => ({
    setIsChanged: (data: boolean) => {
      self.isChanged = data;
    },
    setDiscardData: (discardData: ComponentChecklist[]) => {
      self.tempData = cast(discardData);
    },
  }));

export default SaveChecklist;
